import usePagination from '@/hooks/usePagination';
import { GetProvidersFilters, SortType } from '@/types/schema';

import { useGetProvidersWithIntegrationDetailsQuery } from '../../graphql/queries/generated/getProvidersWithIntegrationDetails';

export default function useProvidersWithIntegrationDetails(
  filters?: GetProvidersFilters,
  sort?: SortType,
) {
  const { data, fetchMore, isFetching, isLoading } = usePagination(
    useGetProvidersWithIntegrationDetailsQuery,
    {
      filters,
      sort,
    },
    { edgeKey: 'providers' },
  );

  return {
    providers: data,
    isFetching,
    fetchMore,
    isLoading,
  };
}
